// Shell i18n — catalogs from src/locales/*.json. This host PRODUCES locale
// (picker → MetaShipGlobalState.updateState) the same way legacy-client does,
// so hosted modules (Boer on boer.metaship.ai / theboer.co.za) consume it via
// @i18n/vue3. See shared/i18n/README.md and docs/i18n.md (TRM-105).
import { createModuleI18n } from "@i18n/vue3";

const messages = Object.fromEntries(
  Object.entries(import.meta.glob("../locales/*.json", { eager: true })).map(
    ([path, mod]) => [
      path.match(/([\w-]+)\.json$/)![1],
      (mod as { default: Record<string, unknown> }).default,
    ],
  ),
);

export const i18n = createModuleI18n(messages);

/** `createModuleI18n` is constructed at import time, before
 *  `installGlobalState()` runs, so its own subscribe is a no-op. Bind after
 *  the host singleton exists so chrome `$t()` follows the picker. */
export function bindI18nToHost(): void {
  const api = window.MetaShipGlobalState;
  if (!api) return;
  const apply = (code: string | undefined) => {
    const next = code || "en";
    if (i18n.global.locale.value !== next) i18n.global.locale.value = next;
  };
  apply(api.state?.locale);
  api.subscribe((state) => apply(state.locale));
}
